import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FollowUpScheduler = ({ isOpen, onClose, onSchedule, clientName }) => {
  const [followUpDate, setFollowUpDate] = useState('');
  const [followUpTime, setFollowUpTime] = useState('');
  const [priority, setPriority] = useState('medium');
  const [notes, setNotes] = useState('');
  const [reminderBefore, setReminderBefore] = useState('1hour');

  const priorityOptions = [
    { value: 'high', label: 'عالية', description: 'متابعة عاجلة' },
    { value: 'medium', label: 'متوسطة', description: 'متابعة عادية' },
    { value: 'low', label: 'منخفضة', description: 'متابعة غير عاجلة' }
  ];

  const reminderOptions = [
    { value: '15min', label: 'قبل ١٥ دقيقة' },
    { value: '30min', label: 'قبل ٣٠ دقيقة' },
    { value: '1hour', label: 'قبل ساعة واحدة' },
    { value: '1day', label: 'قبل يوم واحد' }
  ];

  const handleSchedule = () => {
    if (!followUpDate || !followUpTime) return;
    
    onSchedule({
      date: followUpDate,
      time: followUpTime,
      priority,
      notes,
      reminderBefore,
      clientName
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="w-full max-w-lg bg-card rounded-lg border border-border shadow-warm-xl">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h3 className="text-xl font-heading font-semibold text-foreground">
              جدولة متابعة
            </h3>
            <p className="text-sm text-muted-foreground font-caption mt-1">
              {clientName}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-colors"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              type="date"
              label="تاريخ المتابعة"
              value={followUpDate}
              onChange={(e) => setFollowUpDate(e?.target?.value)}
              required
            />
            <Input
              type="time"
              label="وقت المتابعة"
              value={followUpTime}
              onChange={(e) => setFollowUpTime(e?.target?.value)}
              required
            />
          </div>

          <Select
            label="الأولوية"
            options={priorityOptions}
            value={priority}
            onChange={setPriority}
            required
          />

          <Select
            label="التذكير"
            options={reminderOptions}
            value={reminderBefore}
            onChange={setReminderBefore}
            description="سيتم إرسال تذكير قبل الموعد"
          />

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              ملاحظات المتابعة
            </label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e?.target?.value)}
              placeholder="أضف ملاحظات حول المتابعة..."
              rows={4}
              className="w-full px-4 py-3 text-sm bg-background border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring resize-none"
            />
          </div>

          <div className="flex items-start gap-3 p-4 bg-accent/10 rounded-lg border border-accent/20">
            <Icon name="Bell" size={20} className="text-accent mt-0.5" />
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">
                سيتم إرسال تذكير تلقائي
              </p>
              <p className="text-xs text-muted-foreground mt-1 font-caption">
                ستتلقى إشعاراً في النظام وعبر البريد الإلكتروني قبل الموعد المحدد
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
          >
            إلغاء
          </Button>
          <Button
            variant="default"
            iconName="Calendar"
            iconPosition="right"
            onClick={handleSchedule}
            disabled={!followUpDate || !followUpTime}
          >
            جدولة المتابعة
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FollowUpScheduler;